import { CircularProgress, HStack } from "@chakra-ui/react";

const Loadingtable = () => {
  return (
    <HStack w="100%" placeContent="center">
      <CircularProgress isIndeterminate color="brand.naranja" />
    </HStack>
  );
};

export default Loadingtable;
